import React, { Component } from "react";
import facebook from "../../../Assets/img/Image 45.png";
import twetter from "../../../Assets/img/twitter.svg";
import gmail from "../../../Assets/img/gmail.png";
import { make_request } from "../../Utils/Utils";
import ReCAPTCHA from "react-google-recaptcha";

const subscribe_recaptcha_ref = React.createRef();

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      validation_error: "",
      success_message: "",
    };
  }

  onSubmit = async () => {
    if (!this.state.email) {
      this.setState({
        success_message: false,
        validation_error: "Email cannot be blank",
      });
      return;
    }
 
    if (!this.state.email.includes("@")) {
      this.setState({
        success_message: false,
        validation_error: "Enter a valid email",
      });
      return;
    }
 
    const recaptcha_response = await subscribe_recaptcha_ref.current.executeAsync();
     if (!!recaptcha_response) {
      let responseJson = await make_request({
        path: "subscribe",
        method: "POST",
        content: "JSON",
        body: {
          email: this.state.email,
          recaptcha_response: recaptcha_response,
        },
      });
      if (responseJson)
        this.setState({
          validation_error: false,
          success_message: true,
        });
      else
        this.setState({
          validation_error: true,
        });
    }
  };

  handle_change = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  resetCaptcha = () => {
    subscribe_recaptcha_ref.current.reset();
  };

  render() {
    return (
      <div className="App">
        <footer className="pb-5 pt-5 bg-primary-3 text-light">
          <div className="container">
            <div className="row mb-5">
              <div className="col-lg-4 col-md-6 col-12">
                <h5>About Puzzled</h5>
                <p>
                  Puzzled is an online cryptic riddle, where you get to solve
                  some of the most intelligently crafted levels, providing
                  fodder to the mad genius within you.
                </p>
                <ul className="list-unstyled list-inline list-social mb-6 mb-md-0">
                  <li className="list-inline-item list-social-item mr-3">
                    <a
                      href="https://www.facebook.com/puzzleddotin"
                      className="text-decoration-none"
                    >
                      <img
                        src={facebook}
                        className="social-media-icon"
                        alt="..."
                      />
                    </a>
                  </li>
                  <li className="list-inline-item list-social-item mr-3">
                    <a
                      href="mailto:team@puzzled.in"
                      className="text-decoration-none"
                    >
                      <img
                        src={gmail}
                        className="social-media-icon"
                        alt="..."
                      />
                    </a>
                  </li>
                  <li className="list-inline-item list-social-item mr-3">
                    <a
                      href="https://twitter.com/puzzleddotin/"
                      className="text-decoration-none"
                    >
                      <img
                        src={twetter}
                        className="social-media-icon"
                        alt="..."
                      />
                    </a>
                  </li>
                </ul>
                <p className="mt-4 copyright">Copyright © 2020 Puzzled</p>
              </div>
              {!this.props.noLinks && (
                <React.Fragment>
                  <div className="col-lg-2 col-md-6 col-5">
                    <h5>Quick Links</h5>
                    <ul className="nav flex-column">
                      <li className="nav-item">
                        <a href="/" className="nav-link">
                          Home
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/about-us" className="nav-link">
                          About
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/rules" className="nav-link">
                          RULES
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/hall-of-fame" className="nav-link">
                          HALL OF FAME
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/prizes" className="nav-link">
                          PRIZES
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/editions" className="nav-link">
                          EDITIONS
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-2 col-md-6 col-7">
                    <h5>OTHER LINKS</h5>
                    <ul className="nav flex-column">
                      <li className="nav-item">
                        <a href="/login" className="nav-link">
                          login
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/register" className="nav-link">
                          REGISTER
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/private-puzzled" className="nav-link">
                          Host an Event
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/become-sponsor" className="nav-link">
                          Become a sponsor
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/terms-conditions" className="nav-link">
                        TERMS and CONDITIONS
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/privacy-policy" className="nav-link">
                          Privacy policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </React.Fragment>
              )}

              <div className="col-lg-4 col-md-6 col-12 mailbox">
                <h5>MAILING LIST</h5>
                <p className="mail-text">
                  Get notified on all updates related to Puzzled
                </p>
                <div className="form-row">
                  <div className="col-12">
                    <input
                      type="email"
                      className="form-control mb-2"
                      placeholder="Subscribe to our Newsletter"
                      name="email"
                      value={this.state.email}
                      onChange={this.handle_change}
                    />
                  </div>

                  <div
                    className="d-none alert alert-success"
                    role="alert"
                    data-success-message=""
                  >
                    Thanks, a member of our team will be in touch shortly.
                  </div>

                  <div className="col-lg-4 col-md-4 col-12 text-xs-center">
                    <ReCAPTCHA
                      ref={subscribe_recaptcha_ref}
                      size="invisible"
                      sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
                      onChange={this.resetCaptcha}
                    />
                    <button
                      onClick={this.onSubmit}
                      className="mt-1 ml-1 btn btn-yellow"
                    >
                      Subscribe
                    </button>
                  </div>

                  <div className="col-lg-8 col-md-8 col-12 mb-2 mt-2 text-center">
                   
                    <span className="wrong_txt mb-2 mt-2">
                        {this.state.validation_error}
                    </span>
                    <span className="success_txt">
                        {this.state.success_message && (
                          <span>Thank you for subscribing. We will keep you updated. </span>
                        )}
                    </span>

                  </div>

                  <div className="email_msg mb-2  mt-2 text-center">
                    {this.state.validation_alert && (
                      <p>
                        {" "}
                        Thank you for subscribing. We will keep you updated.{" "}
                      </p>
                    )}
                  </div>
                </div>
                {/* <small className="text-muted form-text">
                  We’ll never share your details. See our{" "}
                  <a href="#">Privacy Policy</a>
                </small> */}
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;
